export default function editHousingCorporationSummaryAdjusted(
  {patch}: any,
  {cid, adjusted}: {cid: number; adjusted: boolean},
): Promise<{}> {
  return patch(
    `/housing-corporations/adjusted`,
    {adjusted, cid},
    {retryOn401: true},
  )
}



// WEBPACK FOOTER //
// ./src/api/endpoints/housingCorporations/editHousingCorporationSummaryAdjusted.tsx